export const NOTIFICATION_LEVEL_INFO = "info";
export const NOTIFICATION_LEVEL_WARNING = "warning";
export const NOTIFICATION_LEVEL_DANGER = "danger";

export const NOTIFICATION_LEVEL_CHOICES: Map<string, string> = new Map([
  [NOTIFICATION_LEVEL_INFO, "Información"],
  [NOTIFICATION_LEVEL_WARNING, "Advertencia"],
  [NOTIFICATION_LEVEL_DANGER, "Crítico"],
]);

export const NOTIFICATION_LEVEL_COLORS: Map<string, string> = new Map([
  [NOTIFICATION_LEVEL_INFO, "info"],
  [NOTIFICATION_LEVEL_WARNING, "warning"],
  [NOTIFICATION_LEVEL_DANGER, "danger"],
]);

export const NOTIFICATION_SOURCE_MANUAL = "manual";
export const NOTIFICATION_SOURCE_AUTOMATIC = "automatic";

export const NOTIFICATION_SOURCE_CHOICES: Map<string, string> = new Map([
  [NOTIFICATION_SOURCE_MANUAL, "Manual"],
  [NOTIFICATION_SOURCE_AUTOMATIC, "Automático"],
]);

interface SystemNotification {
  id?: number;
  type?: string;
  title?: string;
  description?: string;
  level?: string;
  source?: string;
  taxPayerId?: number;
  active?: boolean;
  startsAt?: string;
  expiresAt?: string;
  resolvedAt?: string;
  createdAt?: string;
}

export const newSystemNotification = (): SystemNotification => {
  return { level: NOTIFICATION_LEVEL_INFO, active: true };
};

export default SystemNotification;
